import { Link } from 'react-router-dom';
import { useAdmin, useAuth } from '@/auth/AuthProvider';
import { ChevronNextIcon, LogoutIcon } from '@/components/icons';
import { secondaryNavFor } from '@/components/layout/navItems';
import { PageHeader } from '@/components/ui/PageHeader';

/** תפריט "עוד" בנייד: המסכים שלא נכנסו לניווט התחתון. */
export function MorePage() {
  const { me } = useAdmin();
  const { signOut } = useAuth();

  return (
    <>
      <PageHeader title="עוד" />
      <div className="mb-5 rounded-card border border-line bg-surface p-4">
        <div className="text-[16px] font-semibold">{me.displayName}</div>
        <div className="ltr text-start text-[13px] text-ink-3">{me.email}</div>
      </div>
      <ul className="overflow-hidden rounded-card border border-line bg-surface">
        {secondaryNavFor(me.role).map((item) => (
          <li key={item.to} className="border-b border-line last:border-b-0">
            <Link to={item.to} className="flex min-h-14 items-center gap-3 px-4 text-[16px] active:bg-sunken">
              <span className="text-ink-2">{item.icon}</span>
              <span className="flex-1">{item.label}</span>
              <ChevronNextIcon size={18} className="text-ink-3" />
            </Link>
          </li>
        ))}
      </ul>
      <button
        type="button"
        onClick={() => void signOut()}
        className="mt-5 flex min-h-14 w-full items-center gap-3 rounded-card border border-line bg-surface px-4 text-[16px] text-danger active:bg-sunken"
      >
        <LogoutIcon />
        יציאה
      </button>
    </>
  );
}
